// /connectors/callback: where Salesforce / HubSpot sign-in and Microsoft admin consent return. Posts what came back
// (code or tenant, plus the single-use state) to the API, then goes back to the connector.
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import type { Connector } from "../lib/types";
import { Button, ErrorNote, Spinner, toast } from "../components/ui";

let ran: Promise<Connector> | null = null;

export default function ConnectorCallback() {
  const nav = useNavigate();
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => {
    const q = new URLSearchParams(location.search);
    ran ??= api<Connector>("/admin/oauth-complete", { body: { state: q.get("state"), code: q.get("code"), tenant: q.get("tenant"), error: q.get("error"), error_description: q.get("error_description") } });
    ran.then(
      (c) => {
        toast(`${c.name} connected${c.account ? `: ${c.account}` : ""}`);
        nav(`/company/connectors?open=${c.id}`, { replace: true });
      },
      (e) => setErr((e as Error).message),
    );
  }, [nav]);
  if (!err) return <Spinner label="Connecting…" />;
  return (
    <div className="max-w-lg mx-auto p-6 space-y-4">
      <h1 className="text-lg font-semibold">The connection didn't finish</h1>
      <ErrorNote>{err}</ErrorNote>
      <Button onClick={() => nav("/company/connectors", { replace: true })}>Back to connectors</Button>
    </div>
  );
}
